module.exports = __webpack_public_path__ + "static/media/DC_F_Jacquard_City Life_Bordeaux_PW Pink.exr.540f25c9.png";